import { ROLES } from '../services/firestore';

/**
 * Get the current admin user's role from localStorage.
 * Falls back to 'admin' for existing admins without a role.
 */
export const getAdminRole = () => {
  return localStorage.getItem('AdminRole') || ROLES.ADMIN;
};

export const isAdmin = () => getAdminRole() === ROLES.ADMIN;
export const isDoctor = () => getAdminRole() === ROLES.DOCTOR;
export const isMA = () => getAdminRole() === ROLES.MA;

/** True for admin and doctor — can edit clinical sections (PoC, Diagnosis, Recommendations, etc.) */
export const canEditClinical = () => {
  const role = getAdminRole();
  return role === ROLES.ADMIN || role === ROLES.DOCTOR;
};

/** True for admin only — can manage admin users (create, edit, delete) */
export const canManageAdminUsers = () => getAdminRole() === ROLES.ADMIN;

/** True for admin only — can access portal settings */
export const canAccessSettings = () => getAdminRole() === ROLES.ADMIN;
